module.exports = __webpack_public_path__ + "static/media/engine-fan_green_1.497b8a40.png";